export default "__VITE_ASSET__DGarb3Pb__"